exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Content[data-v-4a751b12]{width:100%;display:-webkit-box;display:flex;box-sizing:border-box;margin:24px;overflow-x:scroll}.Content__Wrapper[data-v-4a751b12]{width:100%;height:100%}.ErrorDialog__DebugMessage[data-v-4a751b12]{color:#fa3e3e;margin-top:8px}", ""]);
